import { motion } from "framer-motion";
import { FileDown, FileText } from "lucide-react";
import { useLang } from "@/lib/content";
import { API_BASE } from "@/lib/api";

const GUIDES = [
  { slug: "128-preguntas", title: { es: "Las 128 preguntas y respuestas", en: "All 128 questions & answers" }, desc: { es: "Guía completa con las respuestas aceptables y el contexto de cada pregunta.", en: "Complete guide with acceptable answers and context for every question." } },
  { slug: "frases-escritura", title: { es: "Frases de lectura y escritura", en: "Reading & writing sentences" }, desc: { es: "Las frases más comunes del dictado con su traducción al español.", en: "The most common dictation sentences with Spanish translations." } },
  { slug: "entrevista-n400", title: { es: "Preguntas de la Entrevista N-400", en: "N-400 interview questions" }, desc: { es: "Vocabulario y respuestas modelo para tu Entrevista Integral.", en: "Vocabulary and model answers for your Full Interview Prep." } },
];

export default function GuidesSection() {
  const { lang } = useLang();
  return (
    <section id="guias" className="bg-paper py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-2xl text-center"
        >
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-heritage">
            {lang === "es" ? "Guías descargables" : "Downloadable guides"}
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-navy sm:text-5xl">
            {lang === "es" ? "Llévate todo en PDF, " : "Take it all with you — "}
            <span className="italic text-heritage">{lang === "es" ? "gratis" : "free PDFs"}</span>
          </h2>
          <p className="mt-4 text-inkbody">
            {lang === "es" ? "Imprímelas o guárdalas en tu celular para repasar en el autobús, en el trabajo o antes de dormir." : "Print them or save them on your phone to review on the bus, at work, or before bed."}
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {GUIDES.map((g, i) => (
            <motion.article
              key={g.slug}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`guide-card-${i}`}
              className="flex flex-col rounded-3xl border border-line bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-heritage/10 text-heritage">
                <FileText size={20} />
              </span>
              <h3 className="mt-4 text-lg font-bold text-navy">{g.title[lang]}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-inkbody">{g.desc[lang]}</p>
              <a
                href={`${API_BASE}/guides/${g.slug}`}
                download
                data-testid={`guide-download-${g.slug}`}
                className="mt-6 inline-flex items-center justify-center gap-2 rounded-full border border-navy/15 px-5 py-3 text-xs font-bold text-navy transition-all hover:border-navy/50 hover:bg-paperdeep"
              >
                <FileDown size={15} /> PDF
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
